import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vehicleUtilityAPI = createApi({
    reducerPath: "vehicleUtilityAPI",
    baseQuery,
    endpoints: (builder) => ({

        // GET /api/v1/admin/vehicle/master/utility
        // No params needed — returns full list
        getAllVehicleUtilities: builder.mutation({
            query: () => ({
                url: `/vehicle/utility`,
                method: "GET",
            }),
            transformResponse: (response) => response,
            providesTags: ["vehicleUtility"],
        }),

        // POST /api/v1/admin/vehicle/master/utility
        // Body: { name, description }
        createVehicleUtility: builder.mutation({
            query: ({ body }) => ({
                url: `/vehicle/utility`,
                method: "POST",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["vehicleUtility"],
        }),

        // PUT /api/v1/admin/vehicle/master/utility/{id}
        // Body: { name, description }
        updateVehicleUtility: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vehicle/utility/${id}`,
                method: "PUT",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["vehicleUtility"],
        }),

        // DELETE /api/v1/admin/vehicle/master/utility/{id}
        deleteVehicleUtility: builder.mutation({
            query: ({ id }) => ({
                url: `/vehicle/utility/${id}`,
                method: "DELETE",
                body: {},
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["vehicleUtility"],
        }),

        // POST /api/v1/admin/vehicle/master/utility/batch
        // Used for CSV bulk upload
        // Body: { utilities: [{ name, description }, ...] }
        batchCreateVehicleUtility: builder.mutation({
            query: ({ body }) => ({
                url: `/vehicle/utility/batch`,
                method: "POST",
                body,
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["vehicleUtility"],
        }),
    }),
});

export const {
    useGetAllVehicleUtilitiesMutation,
    useCreateVehicleUtilityMutation,
    useUpdateVehicleUtilityMutation,
    useDeleteVehicleUtilityMutation,
    useBatchCreateVehicleUtilityMutation,
} = vehicleUtilityAPI;

export default vehicleUtilityAPI;